'use strict';/* global define */define('modules/ui/directives/bullet-pager/controller',['require','exports','module'],function(require,exports,module){'use strict';// @ngInject
     controller.$inject = ["$scope"];
function controller($scope){// jshint validthis:true
// jshint latedef:false
var ctrl=this;ctrl.numberOfPages=+$scope.numberOfPages;ctrl.pages=new Array(ctrl.numberOfPages);ctrl.goToPage=goToPage;// ---
/**
     * [goToNextPage description]
     * @return {[type]} [description]
     */function goToPage(index){if(index>=0&&index<$scope.numberOfPages){$scope.currentPage=index;}}}module.exports=controller;});
